import { useEffect, useState, React } from "react";
import { BrowserRouter, Route, Routes, Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../Hooks/useAuthContext";
import Spinner from "../../Components/Loading/Spinner";
import AvatarEditor from "../../Components/Forms/AvatarEditor";
import SubmittingDialog from "../../Components/Loading/SubmittingDialog";

// Libraries
import Form from "react-bootstrap/Form";




export default function CreateSupplier() {
    const params = useParams();
    const { dispatch, user } = useAuthContext();
    const navigate = useNavigate();
    const [error, setError] = useState();
    const [formErrors, setFormErrors] = useState({ firstName: "" });
    const [form, setForm] = useState({typeOfFarm: "Beef"});
    const [isValid, setIsValid] = useState(false);
    const [submitting, setSubmitting] = useState(false);




    const setField = (field, value) => {
        setForm({
            ...form,
            [field]: value,
        });
    };

    useEffect(() => {

        if (isValid) {
            setSubmitting(true);
            axios
                .post(`https://${process.env.REACT_APP_IP}/api/suppliers/`, form, { headers: { Authorization: `bearer ${user.token}` } })
                .then((res) => {
                    console.log("response:", res);
                    setSubmitting(false);

                    if (res.status === 200) {
                        navigate(`/Suppliers/View/${res.data.id}`)
                    }
                })
                .catch((err) => {
                    console.log(err.response.data);
                    setSubmitting(false);



                    if (err.code === "ERR_NETWORK") {
                        setFormErrors({ general: "Connection to the server could not be established. Please try again in a few minutes" });
                    }
                    else if (err.code === "ERR_BAD_REQUEST") {
                        setFormErrors(err.response.data.errors);
                    }
                    else if (err.response.status === 401) {
                        dispatch({ type: "LOGOUT" })
                        navigate("../")
                    }
                    else {
                        setFormErrors({ general: "An unknown error occured. " + err.code });
                    }
                });
        }
    }, [isValid]);

    useEffect(() => {
        setIsValid(formErrors.name === "")
    }, [formErrors])

    const handleSubmit = (event) => {
        event.preventDefault();

        setFormErrors({
            name: form.name === undefined || form.name === "" ? "Supplier name is required" : "",
            
        });
    }

    
    



    return (
        <div className="page">

            {submitting && (
                <SubmittingDialog />
            )}

            <div className="row">
                <div className="col-12">
                    <h1>
                      Create Supplier
                    </h1>
                </div>
            </div>

            <Form onSubmit={handleSubmit} noValidate >

            
            <div className="row">
                {/* Contact Details */}
                <div className="col-md-6">
                    <h3>Contact Details</h3>

                   
                    <div className="row">
                        <div className="col-md-12">
                            { /* Supplier Name */}
                            <div className="form-group">
                                <label>Supplier Name</label>
                                <Form.Control
                                    required
                                    type="text"
                                    placeholder="e.g John Smith Foods"
                                    isInvalid={formErrors && formErrors.name}
                                    onChange={(e) => setField("name", e.target.value)}
                                    value={form.name ?? ""}
                                />
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    {formErrors.name}
                                </Form.Control.Feedback>
                            </div>
                        </div>
                        
                    </div>

                   
                    { /* Address */}
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Address</label>
                                <Form.Control as="textarea" rows="5"
                                    placeholder="e.g Suite 12B"
                                    isInvalid={formErrors && formErrors.address}
                                    onChange={(e) => setField("address", e.target.value)}
                                    value={form.address ?? ""}
                                />
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    {formErrors.address}
                                </Form.Control.Feedback>
                            </div>
                        </div>
                    </div>

                    { /* Postcode */}
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Postcode</label>
                                <Form.Control
                                    type="text"
                                    placeholder="e.g CA1 1AA"
                                    isInvalid={formErrors && formErrors.postcode}
                                    onChange={(e) => setField("postcode", e.target.value)}
                                    value={form.postcode ?? ""}
                                />
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    {formErrors.postcode}
                                </Form.Control.Feedback>
                            </div>
                        </div>
                    </div>

                    { /* Telephone */}
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Telephone</label>
                                <Form.Control
                                    type="tel"
                                    placeholder="e.g 01228 123456"
                                    isInvalid={formErrors && formErrors.telephone}
                                    onChange={(e) => setField("telephone", e.target.value)}
                                    value={form.telephone ?? ""}
                                />
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    {formErrors.telephone}
                                </Form.Control.Feedback>
                            </div>
                        </div>
                    </div>

                   

                    { /* Email */}
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label>Email</label>
                                <Form.Control
                                    required
                                    type="email"
                                    placeholder="e.g john@smith.com"
                                    isInvalid={formErrors && formErrors.email}
                                    onChange={(e) => setField("email", e.target.value)}
                                    value={form.email ?? ""}
                                />
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    {formErrors.email}
                                </Form.Control.Feedback>
                            </div>
                        </div>
                    </div>

                    

                   

                    

                        
                    
                </div>

                {/* Other Details */}
                <div className="col-md-6">
                    <h3>Other Details</h3>
                    { /* Account Number */}
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Account Number</label>
                                <Form.Control
                                    type="text"
                                    placeholder="e.g AFS123"
                                    isInvalid={formErrors && formErrors.accountNumber}
                                    onChange={(e) => setField("accountNumber", e.target.value)}
                                    value={form.accountNumber ?? ""}
                                />
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    {formErrors.accountNumber}
                                </Form.Control.Feedback>
                            </div>
                        </div>
                    </div>

                    

                    { /* Who Invoices? */}
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <Form.Check
                                    type="radio"
                                    isInvalid={formErrors && formErrors.afsToInvoice}
                                    onChange={(e) => setField("afsToInvoice", e.target.checked)}
                                    checked={form.afsToInvoice ? true : false}
                                    label="AFS To Invoice" />
                                <Form.Check
                                    type="radio"
                                    isInvalid={formErrors && formErrors.afsToInvoice}
                                    onChange={(e) => setField("afsToInvoice", e.target.checked)}
                                    checked={form.afsToInvoice ? false : true}
                                    label="Supplier To Invoice" />
                                    
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    {formErrors.afsToInvoice}
                                </Form.Control.Feedback>
                            </div>
                        </div>
                    </div>

                    { /* Notes */}
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label>Notes</label>
                                <Form.Control as="textarea" rows="5"
                                    placeholder="e.g Order before 3pm"
                                    isInvalid={formErrors && formErrors.notes}
                                    onChange={(e) => setField("notes", e.target.value)}
                                    value={form.notes ?? ""}
                                />
                                <Form.Control.Feedback className="text-danger" type="invalid">
                                    {formErrors.notes}
                                </Form.Control.Feedback>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            


            <hr />

            {formErrors.general && (
                <div className="row">
                    <div className="col-md-12">
                        <div className="alert alert-danger">
                                {formErrors.general}
                        </div>
                    </div>
                </div>
            )}

            <div className="row">
                <div className="col-md-12">
                    <button className="btn btn-primary">Create Supplier</button>
                    <button className="btn btn-other" style={{ marginLeft: 10 }} onClick={() => { navigate(`/Suppliers/`) }}>Cancel</button>
                </div>
            </div>
            </Form>

        </div>
  )
}
